// 动态增加表单 // 点击加减号进行输入框增减 // 传参：{ }
<template>
  <div>
    <el-form
      :ref="dynamicValidateForm.ref"
      :inline="true"
      class="isOnly"
      v-for="(item, index) in dynamicValidateForm.dynamicItem"
      :key="index"
      :model="item"
      :label-width="dynamicValidateForm.labelWidth"
    >
      <form-control
        v-for="(inp, i) in dynamicValidateForm.inputItem"
        :key="inp.prop + i"
        :controlItem="inp"
        :dynamicItem="item"
        v-on="$listeners"
      />
      <!-- 加减号标签 -->
      <el-form-item class="addOrMenus">
        <i
          v-show="inputArr !== 1"
          class="el-icon-remove-outline"
          @click="removeDomain(item, index)"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Form from "./form.vue";
// 引入表单控件
import FormControl from "./FormControl.vue";
import { mapGetters } from "vuex";
export default {
  components: { FormControl, Form },
  props: {
    loading: false,
    dynamicValidateForm: {
      ref: "",
      isTrue: "",
      labelWidth: "130px",
      dynamicItem: [{}],
      inputItem: [
        {
          // 选择类型
          type: "Input",
          // 绑定表单
          model: "email",
          // 控件名称
          label: "",
          // 控件属性名
          prop: "",
          // 控件子节点值
          value: [],
          // 是否可以动态增减
          isDynamic: true,
          // 控件配置
          props: {},
        },
      ],
      deleteItem: [],
    },
  },

  data() {
    return {
      // 检测有几排输入框如果只有一排则减号不显示
      inputArr: 1,
      model: "",
    };
  },
  computed: {
    form_loading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("changeLoading", val);
      },
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.dynamicValidateForm.dynamicItem.indexOf(item);
      if (index !== -1) {
        if (typeof item["Status"] && item["Status"] !== 1) {
          let [obj] = this.dynamicValidateForm.dynamicItem.splice(index, 1);
          [obj].length > 0 ? this.dynamicValidateForm.deleteItem.push(obj) : "";
        } else {
          this.dynamicValidateForm.dynamicItem.splice(index, 1);
        }
        this.addBtn();
      }
    },
    // 添加新增按钮
    addBtn() {
      //判断是否只有一个可新增输入框
      const iconArr = document.getElementsByClassName("el-icon-remove-outline");
      const inputArr = document.getElementsByClassName("isOnly");
      this.inputArr = inputArr.length;
      $(`<i class="el-icon-circle-plus-outline" />`).insertAfter(
        iconArr[iconArr.length - 1]
      );
      const that = this;
      // 添加事件绑定
      let newObj = {};
      // 这里有值才进，没有值就不进。
      if (this.dynamicValidateForm.dynamicItem) {
        for (const key in this.dynamicValidateForm.dynamicItem[0]) {
          newObj[key] = "";
        }
        $(".el-icon-circle-plus-outline").click(function () {
          if (typeof newObj["Status"]) {
            newObj["Status"] = 1;
            newObj["ID"] = "";
          }
          that.dynamicValidateForm.dynamicItem.push(newObj);
        });
      }
    },
    handelValidate(data) {
      this.$emit("dynamicValidate", data);
    },
    async validateForm(ref) {
      let valid = await ref.validate().catch((err) => {
        return false;
      });
      return valid;
    },
  },

  mounted() {
    this.$nextTick(function () {
      this.$on("ConfirmFunc", async function (val) {
        let dyref = this.dynamicValidateForm.ref;
        let res = [];
        for (let i = 0; i < this.$refs[dyref].length; i++) {
          res[i] = await this.validateForm(this.$refs.dynamicItem[i]);
        }
        if (val["ref"]) {
          const { ref } = val;
          ref.validate((valid) => {
            console.log(valid);
            if (valid && res.every((item) => item)) {
              this.$emit("handleClick");
              return true;
            } else {
              this.form_loading = false;
              return false;
            }
          });
        } else {
          if (res.every((item) => item)) {
            this.$emit("handleClick");
            return true;
          } else {
            this.form_loading = false;
            return false;
          }
        }
      });
    });
    this.addBtn();
  },
  updated() {
    $(".el-icon-circle-plus-outline").remove();
    this.addBtn();
  },
};
</script>

<style scoped>
.el-input {
  width: 280px !important;
}
</style>

<style>
/* 图标 */
.el-icon-remove-outline::before {
  color: #5691f2;
  font-size: 20px;
}
.el-icon-circle-plus-outline::before {
  color: #5691f2;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/dynamicValidateForm.vue